import React, { useState } from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { ReactSVG } from 'react-svg';
import styles from './ActionMenu.module.css';
import { Icons } from '@/assets';
import IconButton from '@/ctComponents/IconButton';

const ActionMenu = ({
  anchorEl,
  onClose,
  menuItems = [],
  className,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  componentName,
  handleEditTemplate,
  handleDeleteTemplate,
  setShowDeleteTemplateModal,
  setClickedTemplate,
  getContentAnchorEl,
}) => {
  // Smart positioning logic for loadAutobookTemplate in inventory mode
  const [dynamicAnchorOrigin, setDynamicAnchorOrigin] = useState(anchorOrigin);
  const [dynamicTransformOrigin, setDynamicTransformOrigin] =
    useState(transformOrigin);

  React.useEffect(() => {
    if (
      anchorEl &&
      componentName === 'loadAutobookTemplate' &&
      getContentAnchorEl === null
    ) {
      // For loadAutobookTemplate in modal (when getContentAnchorEl is null), use provided anchorOrigin and transformOrigin
      setDynamicAnchorOrigin(anchorOrigin);
      setDynamicTransformOrigin(transformOrigin);
    } else if (anchorEl) {
      // For other components or loadAutobookTemplate outside modal, use smart positioning
      const rect = anchorEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const menuHeight = 120;
      if (windowHeight - rect.bottom < menuHeight) {
        setDynamicAnchorOrigin({ vertical: 'top', horizontal: 'right' });
        setDynamicTransformOrigin({ vertical: 'bottom', horizontal: 'right' });
      } else {
        setDynamicAnchorOrigin({ vertical: 'bottom', horizontal: 'right' });
        setDynamicTransformOrigin({ vertical: 'top', horizontal: 'right' });
      }
    }
  }, [
    anchorEl,
    componentName,
    anchorOrigin,
    transformOrigin,
    getContentAnchorEl,
  ]);

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      PaperProps={{
        style: {
          maxHeight: '300px',
          ...(componentName === 'loadAutobookTemplate' && {
            width: '273px',
            ...(getContentAnchorEl === null &&
            componentName === 'loadAutobookTemplate'
              ? {
                  marginTop: '-40px',
                }
              : {
                  translate: '90px 0px',
                }),
          }),
        },
      }}
      classes={{
        paper: `${styles.menuPaper} ${className || ''}`,
      }}
      anchorOrigin={dynamicAnchorOrigin}
      transformOrigin={dynamicTransformOrigin}
      getContentAnchorEl={getContentAnchorEl}
      MenuListProps={{ disablePadding: true }}>
      {menuItems.map((item, index) => (
        <MenuItem
          key={item.id || index}
          onClick={() => {
            if (componentName !== 'loadAutobookTemplate') {
              if (item.onClick) {
                item.onClick();
                onClose();
              }
            }
          }}
          className={`${styles.menuItem} ${item.className || ''}`}
          disabled={item.disabled}>
          {item.icon && <ReactSVG src={item.icon} className={styles.icon} />}
          <span
            onClick={() => {
              if (componentName === 'loadAutobookTemplate') {
                if (item.onClick) {
                  item.onClick();
                  onClose();
                }
              }
            }}
            className={styles.menuItemText}>
            {item.label}
          </span>
          {item.description && (
            <span className={styles.menuItemDescription}>
              {item.description}
            </span>
          )}
          {componentName === 'loadAutobookTemplate' && (
            <span className={styles.menuItemActions}>
              <IconButton
                style={{ border: 'none', width: '40px' }}
                onClick={() => {
                  setClickedTemplate(item);
                  handleEditTemplate(item);
                  onClose();
                }}
                icon={'pen'}
                // text={'Load'}
                color={'#131617'}
                size={'mini'}
              />
              <IconButton
                style={{ border: 'none', width: '40px' }}
                onClick={() => {
                  setClickedTemplate(item);
                  setShowDeleteTemplateModal(true);
                  onClose();
                }}
                icon={'trashIcon'}
                // text={'Load'}
                color={'#fb3f4f'}
                size={'mini'}
              />
            </span>
          )}
        </MenuItem>
      ))}
      {menuItems.length === 0 && (
        <MenuItem className={`${styles.menuItem}`} disabled>
          No items available
        </MenuItem>
      )}
    </Menu>
  );
};

export default ActionMenu;
